import { pageClass } from "./Page";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PDF(props) {
    return /*#__PURE__*/ _jsxs("div", { children: [/*#__PURE__*/ _jsx("style", { children: `
                @page wide {
                    size: 11in 8.5in;
                    margin: 10mm;
                }
                
                @page narrow {
                    size: 8.5in 11in;
                    margin: 10mm;
                }
                
                @page square {
                    size: 11in 11in;
                    margin: 10mm;
                }
            ` }), !props.interactive && /*#__PURE__*/ _jsx("div", { className: pageClass, style: { page: "square" }, children: "blank page to remove" }), props.children] });
}
